// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import {
  useSetting,
  useAssignSetting,
} from "@faire/marketplace-lib/settings/__internal__/useSetting";
import { IN_SESSION_CART_BUILDING_AND_SAVINGS_GUIDE_RELAUNCH_250723 } from "@faire/web-api--source/indigofair/settings/IN_SESSION_CART_BUILDING_AND_SAVINGS_GUIDE_RELAUNCH_250723";

// This setting is used for both pre and post FCO. The pre FCO setting is no longer used.
// Analysis for the two audiences will be done in offline.
export const useSettingCartBuildingAndSavingsGuide = (): boolean =>
  useSetting(IN_SESSION_CART_BUILDING_AND_SAVINGS_GUIDE_RELAUNCH_250723, false);

export const useAssignSettingCartBuildingAndSavingsGuide = () =>
  useAssignSetting(IN_SESSION_CART_BUILDING_AND_SAVINGS_GUIDE_RELAUNCH_250723);
